import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Navbar from "./components/Navbar";
import { ToastContainer } from "react-toastify";
import LoginPage from "./pages/LoginPage";
import RequiredAuth from "./routes/RequiredAuth";
import RequiredNoAuth from "./routes/RequiredNoAuth";
import Exchange from "./components/Exchange";
import { appRoutes } from "./routes/routeConfig";
import { TabsProvider } from "./components/tabs/TabsContext";
import TabBar from "./components/tabs/TabBar";
import TabPanels from "./components/tabs/TabPanels";

// Her sekme bu rotaları kendi adresiyle render eder
const tabRoutes = (
  <Route element={<RequiredAuth allowedRoles={["MANAGER", "ADMIN", "SALES", "DEPOT"]} />}>
    {
      appRoutes.map(({ path, title, Component }) => (
        <Route key={path} path={path} element={<Component title={title} />} />
      ))
    }
  </Route>
)

const App = () => {

  const isLoggedIn = useSelector(state => state.auth.value.isLoggedIn)
  const location = useLocation()

  return (
    <div className="relative grid grid-cols-12 h-screen columns-12">
      <div className="col-span-1">
        <Navbar />
      </div>
      <TabsProvider enabled={isLoggedIn}>
        {
          isLoggedIn
            ? <div className="col-span-11 flex flex-col h-screen bg-zinc-50 dark:bg-zinc-900">
              <div className="px-5 pt-5">
                <Exchange />
              </div>
              <TabBar />
              {
                location.pathname === '/login'
                  ? <Navigate to='/' replace />
                  : <TabPanels routes={tabRoutes} />
              }
            </div>
            : <div className="col-span-11 overflow-auto bg-zinc-50 p-5 dark:bg-zinc-900">
              <div>
                <Exchange />
              </div>
              <Routes>
                <Route element={<RequiredNoAuth />} >
                  <Route path="/login" element={<LoginPage title='Giriş' />} />
                </Route>
                <Route path="*" element={<Navigate to='/login' state={{ from: location }} replace />} />
              </Routes>
            </div>
        }
      </TabsProvider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
